var _circle, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.917,
    cy: 28,
    r: 28,
    fill: "#F4F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.0723 20.6057C33.0723 17.8263 33.0723 16.4381 33.8939 15.5745C34.7155 14.7109 36.0363 14.7109 38.6807 14.7109C41.3251 14.7109 42.6459 14.7109 43.4676 15.5745C44.2892 16.4381 44.2892 17.8263 44.2892 20.6057C44.2892 23.385 44.2892 24.7733 43.4676 25.6368C42.6459 26.5004 41.3251 26.5004 38.6807 26.5004C36.0363 26.5004 34.7155 26.5004 33.8939 25.6368C33.0723 24.7733 33.0723 23.385 33.0723 20.6057Z",
    stroke: "url(#paint0_linear_3637_10572)",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8496 20.3947C17.8496 17.6154 17.8496 16.2272 18.6713 15.3636C19.4929 14.5 20.8137 14.5 23.4581 14.5C26.1025 14.5 27.4233 14.5 28.2449 15.3636C29.0666 16.2272 29.0666 17.6154 29.0666 20.3947C29.0666 23.1741 29.0666 24.5623 28.2449 25.4259C27.4233 26.2895 26.1025 26.2895 23.4581 26.2895C20.8137 26.2895 19.4929 26.2895 18.6713 25.4259C17.8496 24.5623 17.8496 23.1741 17.8496 20.3947ZM33.2729 36.6053C33.2729 33.8259 33.2729 32.4377 34.0946 31.5741C34.9162 30.7105 36.237 30.7105 38.8814 30.7105C41.5258 30.7105 42.8466 30.7105 43.6682 31.5741C44.4899 32.4377 44.4899 33.8259 44.4899 36.6053C44.4899 39.3846 44.4899 40.7728 43.6682 41.6364C42.8466 42.5 41.5258 42.5 38.8814 42.5C36.237 42.5 34.9162 42.5 34.0946 41.6364C33.2729 40.7728 33.2729 39.3846 33.2729 36.6053Z",
    stroke: "url(#paint1_linear_3637_10572)",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.8496 36.6052C17.8496 33.8258 17.8496 32.4376 18.6713 31.574C19.4929 30.7104 20.8137 30.7104 23.4581 30.7104C26.1025 30.7104 27.4233 30.7104 28.2449 31.574C29.0666 32.4376 29.0666 33.8258 29.0666 36.6052C29.0666 39.3846 29.0666 40.7728 28.2449 41.6363C27.4233 42.4999 26.1025 42.4999 23.4581 42.4999C20.8137 42.4999 19.4929 42.4999 18.6713 41.6363C17.8496 40.7728 17.8496 39.3846 17.8496 36.6052Z",
    stroke: "url(#paint2_linear_3637_10572)",
    strokeWidth: 2.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3637_10572",
    x1: 33.0723,
    y1: 14.7109,
    x2: 44.8471,
    y2: 25.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3637_10572",
    x1: 17.8496,
    y1: 14.5,
    x2: 45.815,
    y2: 41.1073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3637_10572",
    x1: 17.8496,
    y1: 30.7104,
    x2: 29.6245,
    y2: 41.9135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.508569e12d19de41997e96af87f7e1f0.svg";
export { ForwardRef as ReactComponent };